import { useIntl } from "react-intl";

const FeaturedArticles = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.FeaturedArticles.header",
            defaultMessage: "Featured articles"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.FeaturedArticles.body",
            defaultMessage:
                "Help customers self-serve by featuring relevant articles at the top of each help center category. This is especially useful to highlight articles that are commonly used by customers."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default FeaturedArticles;
